/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// local components
import SkipNav from './components/SkipNav';
import UtilityNavigation from './components/UtilityNavigation';
import InformationalBanner from '../../modules/InformationalBanner';
import Icon from '../../base/Icon';

import { navScript } from '../../../assets/js/helpers/nav.header';

export const HeaderComponent = ({
  env,
  hideHeader,
  headerIsOverlayed,
  headerLogoEyebrow,
  headerLogoEyebrowLarge,
  headerWithoutBorder,
  showInformationalBanner,
  skipNavAside,
}) => {
  const { basePath, nmxTemplateVersion } = env;

  useEffect(() => {
    // once component is mounted, we can get the nav js on the page
    setTimeout(() => {
      // TODO the nav is not ready at component load to readjust the nav item locations, small timeout to help with that -- TODO need better solution
      navScript();
    }, 100);
  }, []);

  return (
    <React.Fragment>
      <header
        id="nmx-header"
        className={`nmx-header nmx-base ${hideHeader
          && 'is-logo-only'} ${hideHeader
          && headerIsOverlayed
          && 'is-overlayed'} ${hideHeader
          && headerLogoEyebrow
          && 'has-logo-eyebrow'} ${hideHeader
          && headerLogoEyebrow
          && headerLogoEyebrowLarge
          && 'has-logo-eyebrow-large'} ${headerIsOverlayed
          && 'is-overlayed'} ${headerWithoutBorder && 'without-border'}`}>
        <div className="nmx-container">
          <SkipNav skipNavAside={skipNavAside} />
          {showInformationalBanner && (
            <InformationalBanner />
          )}
          {!hideHeader && (
            <div className="nmx-header-mobile-container">
              {/* TODO: rename aria-label value to open/close */}
              <button
                id="nav-toggle"
                className="nmx-button"
                aria-label="Toggle Mobile Menu">
                <span className="nav-toggle-bar"></span>
              </button>
              <div className="nmx-mobile-nav-overlay"></div>
            </div>
          )}
          <div className="nmx-container-inner" id="nmx-mobile-nav-container">
            <div className="nmx-row">
              <div className="nmx-col nmx-nav-primary-container">
                <h6
                  className="nmx-header-logo-container"
                  id="header-logo-heading">
                  <a className="nmx-header-logo" href="/" id="header-logo">
                    Northwestern Mutual
                    {/* TODO: clean up SVG markup (change "NW" to "nm" clean up IDs, descriptions, titles, etc.) */}
                  </a>
                  <meta
                    itemProp="image"
                    content={`${basePath}/template/assets/${nmxTemplateVersion}/images/logo-horizontal-navy.svg`}
                  />
                  <img
                    src={`${basePath}/template/assets/${nmxTemplateVersion}/images/logo-horizontal-navy.svg`}
                    className="nmx-print"
                    alt="Northwestern Mutual"
                  />
                </h6>
                {/* remove non-applied DOM elements if logo-only header */}
                {!hideHeader && (
                  <nav
                    itemScope
                    itemType="https://schema.org/SiteNavigationElement"
                    className="nmx-nav-primary"
                    id="nmx-nav-primary">
                    <h6 className="nmx-assistive-text">Primary Navigation</h6>
                    <ul role="menubar" className="reduced">
                      <li
                        role="none"
                        className="nmx-nav-link-container nmx-nav-link-primary-container nmx-nav-link-mobile-primary-home-container">
                        <a
                          role="menuitem"
                          tabIndex="-1"
                          className="nmx-nav-link nmx-nav-link-mobile-primary-home"
                          href={`${basePath}/`}>
                          Home
                        </a>
                      </li>
                      <li
                        role="none"
                        itemProp="name"
                        className="nmx-nav-link-container nmx-nav-link-primary-container">
                        <a
                          role="menuitem"
                          itemProp="url"
                          aria-haspopup="true"
                          aria-label="Who we are"
                          className="nmx-nav-link nmx-nav-link-primary"
                          href={`${basePath}/who-we-are`}
                          id="nmx-nav-link-primary-who-we-are"
                          data-subnav-active="false"
                          aria-expanded="false">
                          Who We Are
                        </a>
                        <ul
                          role="menu"
                          className="reduced nmx-subnav nmx-subnav-who-we-are"
                          aria-label="Who We Are Submenu">
                          <li
                            role="none"
                            className="nmx-nav-link-container nmx-nav-link-mobile-back-container">
                            <button
                              role="menuitem"
                              tabIndex="-1"
                              className="nmx-button nmx-button--tertiary nmx-nav-link nmx-nav-link-primary-sub--first nmx-nav-link-mobile-back">
                              Back to main menu
                              <span className="nmx-nav-mobile-subnav-bg"></span>
                            </button>
                          </li>
                          <li
                            role="none"
                            className="nmx-nav-link-container nmx-nav-link-mobile-subnav-overview-container">
                            <a
                              role="menuitem"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-mobile-subnav-overview"
                              href={`${basePath}/who-we-are`}>
                              Who We Are Overview
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/working-with-an-advisor"
                              id="nmx-nav-link-primary-sub-working-with-an-advisor"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-who-we-are">
                              Working With an Advisor
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/financial-information"
                              id="nmx-nav-link-primary-sub-our-financial-strength"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-nav-link-primary-sub--last nmx-subnav-item-who-we-are">
                              Our Financial Strength
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li
                        role="none"
                        itemProp="name"
                        className="nmx-nav-link-container nmx-nav-link-primary-container">
                        <a
                          role="menuitem"
                          itemProp="url"
                          aria-haspopup="true"
                          className="nmx-nav-link nmx-nav-link-primary"
                          href="/planning-services"
                          id="nmx-nav-link-primary-planning-services"
                          data-subnav-active="false"
                          aria-expanded="false">
                          Planning Services
                        </a>
                        <ul
                          role="menu"
                          className="reduced nmx-subnav nmx-subnav-planning-services"
                          aria-label="Planning Services Submenu">
                          <li
                            role="none"
                            className="nmx-nav-link-container nmx-nav-link-mobile-back-container">
                            <button
                              role="menuitem"
                              tabIndex="-1"
                              className="nmx-button nmx-button--tertiary nmx-nav-link nmx-nav-link-primary-sub--first nmx-nav-link-mobile-back">
                              Back to main menu
                              <span className="nmx-nav-mobile-subnav-bg"></span>
                            </button>
                          </li>
                          <li
                            role="none"
                            className="nmx-nav-link-container nmx-nav-link-mobile-subnav-overview-container">
                            <a
                              role="menuitem"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-mobile-subnav-overview"
                              href={`${basePath}/planning-services`}>
                              Planning Services Overview
                            </a>
                          </li>
                          <li
                            role="none"
                            className="nmx-nav-link-container nmx-nav-link-primary-sub-container">
                            <a
                              role="menuitem"
                              href="/retirement-planning"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-planning-services has-subnav-level2"
                              id="nmx-nav-link-primary-sub-retirement-planning"
                              aria-haspopup="true"
                              aria-expanded="false">
                              Retirement Planning
                            </a>
                            <ul
                              role="menu"
                              className="reduced nmx-subnav-level2 nmx-subnav-level2-retirement-planning"
                              aria-label="Retirement Planning Submenu">
                              <li
                                role="none"
                                className="nmx-nav-link-container nmx-nav-link-mobile-level2-back-container">
                                <button
                                  role="menuitem"
                                  tabIndex="-1"
                                  className="nmx-button nmx-button--tertiary nmx-nav-link nmx-nav-link-primary-sub-level2--first nmx-nav-link-mobile-level2-back">
                                  Back to Planning Services
                                  <span className="nmx-nav-mobile-subnav-bg"></span>
                                </button>
                              </li>
                              <li
                                role="none"
                                className="nmx-nav-link-container nmx-nav-link-mobile-subnav-overview-container">
                                <a
                                  role="menuitem"
                                  tabIndex="-1"
                                  className="nmx-nav-link nmx-nav-link-mobile-subnav-overview"
                                  href={`${basePath}/retirement-planning`}>
                                  Retirement Planning Overview
                                </a>
                              </li>
                              <li
                                role="none"
                                className="nmx-nav-link-container">
                                <a
                                  role="menuitem"
                                  href="/retirement-calculator"
                                  id="nmx-nav-link-primary-sub-level2-retirement-calculator"
                                  tabIndex="-1"
                                  className="nmx-nav-link nmx-nav-link-primary-sub-level2 nmx-nav-link-primary-sub-level2--last nmx-subnav-level2-item-retirement-planning has-icon">
                                  Retirement Calculator{' '}
                                  <Icon variant="beach-chair-with-border" />
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/college-savings-plans"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-planning-services"
                              id="nmx-nav-link-primary-sub-college-savings-plans">
                              College Savings Plans
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/private-wealth-management"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-planning-services"
                              id="nmx-nav-link-primary-sub-private-wealth-management">
                              Private Wealth Management
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/estate-planning"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-planning-services"
                              id="nmx-nav-link-primary-sub-estate-planning">
                              Estate Planning
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/long-term-care-planning"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-planning-services"
                              id="nmx-nav-link-primary-sub-planning-services-long-term-care">
                              Long&#45;Term Care
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/business-services"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-nav-link-primary-sub--last nmx-subnav-item-planning-services"
                              id="nmx-nav-link-primary-sub-business-services">
                              Business Services
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li
                        role="none"
                        itemProp="name"
                        className="nmx-nav-link-container nmx-nav-link-primary-container">
                        <a
                          role="menuitem"
                          itemProp="url"
                          aria-haspopup="true"
                          className="nmx-nav-link nmx-nav-link-primary"
                          href="/insurance"
                          id="nmx-nav-link-primary-insurance"
                          data-subnav-active="false"
                          aria-expanded="false">
                          Insurance
                        </a>
                        <ul
                          role="menu"
                          className="reduced nmx-subnav nmx-subnav-insurance"
                          aria-label="Insurance Submenu">
                          <li
                            role="none"
                            className="nmx-nav-link-container nmx-nav-link-mobile-back-container">
                            <button
                              role="menuitem"
                              tabIndex="-1"
                              className="nmx-button nmx-button--tertiary nmx-nav-link nmx-nav-link-primary-sub--first nmx-nav-link-mobile-back">
                              Back to main menu
                              <span className="nmx-nav-mobile-subnav-bg"></span>
                            </button>
                          </li>
                          <li
                            role="none"
                            className="nmx-nav-link-container nmx-nav-link-mobile-subnav-overview-container">
                            <a
                              role="menuitem"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-mobile-subnav-overview"
                              href={`${basePath}/insurance`}>
                              Insurance Overview
                            </a>
                          </li>
                          <li
                            role="none"
                            className="nmx-nav-link-container nmx-nav-link-primary-sub-container">
                            <a
                              role="menuitem"
                              href="/life-insurance"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-insurance has-subnav-level2"
                              id="nmx-nav-link-primary-sub-life-insurance"
                              aria-haspopup="true"
                              aria-expanded="false">
                              Life Insurance
                            </a>
                            <ul
                              role="menu"
                              className="reduced nmx-subnav-level2 nmx-subnav-level2-life-insurance"
                              aria-label="Life Insurance Submenu">
                              <li
                                role="none"
                                className="nmx-nav-link-container nmx-nav-link-mobile-level2-back-container">
                                <button
                                  role="menuitem"
                                  tabIndex="-1"
                                  className="nmx-button nmx-button--tertiary nmx-nav-link nmx-nav-link-primary-sub-level2--first nmx-nav-link-mobile-level2-back">
                                  Back to Insurance
                                  <span className="nmx-nav-mobile-subnav-bg"></span>
                                </button>
                              </li>
                              <li
                                role="none"
                                className="nmx-nav-link-container nmx-nav-link-mobile-subnav-overview-container">
                                <a
                                  role="menuitem"
                                  tabIndex="-1"
                                  className="nmx-nav-link nmx-nav-link-mobile-subnav-overview"
                                  href={`${basePath}/life-insurance`}>
                                  Life Insurance Overview
                                </a>
                              </li>
                              <li
                                role="none"
                                className="nmx-nav-link-container">
                                <a
                                  role="menuitem"
                                  href="/whole-life-insurance"
                                  id="nmx-nav-link-primary-sub-level2-whole-life-insurance"
                                  tabIndex="-1"
                                  className="nmx-nav-link nmx-nav-link-primary-sub-level2 nmx-subnav-level2-item-life-insurance">
                                  Whole Life Insurance
                                </a>
                              </li>
                              <li
                                role="none"
                                className="nmx-nav-link-container">
                                <a
                                  role="menuitem"
                                  href="/universal-life-insurance"
                                  id="nmx-nav-link-primary-sub-level2-universal-life-insurance"
                                  tabIndex="-1"
                                  className="nmx-nav-link nmx-nav-link-primary-sub-level2 nmx-subnav-level2-item-life-insurance">
                                  Universal Life Insurance
                                </a>
                              </li>
                              <li
                                role="none"
                                className="nmx-nav-link-container">
                                <a
                                  role="menuitem"
                                  href="/term-life-insurance"
                                  id="nmx-nav-link-primary-sub-level2-term-life-insurance"
                                  tabIndex="-1"
                                  className="nmx-nav-link nmx-nav-link-primary-sub-level2 nmx-subnav-level2-item-life-insurance">
                                  Term Life Insurance
                                </a>
                              </li>
                              <li
                                role="none"
                                className="nmx-nav-link-container">
                                <a
                                  role="menuitem"
                                  href="/life-insurance-calculator"
                                  id="nmx-nav-link-primary-sub-level2-life-insurance-calculator"
                                  tabIndex="-1"
                                  className="nmx-nav-link nmx-nav-link-primary-sub-level2 nmx-nav-link-primary-sub-level2--last nmx-subnav-level2-item-life-insurance has-icon">
                                  Life Insurance Calculator
                                  <Icon variant="heart-shield-with-border" />
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li
                            role="none"
                            className="nmx-nav-link-container nmx-nav-link-primary-sub-container">
                            <a
                              role="menuitem"
                              href="/disability-insurance"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-insurance has-subnav-level2"
                              id="nmx-nav-link-primary-sub-disability-insurance"
                              aria-haspopup="true"
                              aria-expanded="false">
                              Disability Insurance
                            </a>
                            <ul
                              role="menu"
                              className="reduced nmx-subnav-level2 nmx-subnav-level2-disability-insurance"
                              aria-label="Disability Insurance Submenu">
                              <li
                                role="none"
                                className="nmx-nav-link-container nmx-nav-link-mobile-level2-back-container">
                                <button
                                  role="menuitem"
                                  tabIndex="-1"
                                  className="nmx-button nmx-button--tertiary nmx-nav-link nmx-nav-link-primary-sub-level2--first nmx-nav-link-mobile-level2-back">
                                  Back to Insurance
                                  <span className="nmx-nav-mobile-subnav-bg"></span>
                                </button>
                              </li>
                              <li
                                role="none"
                                className="nmx-nav-link-container nmx-nav-link-mobile-subnav-overview-container">
                                <a
                                  role="menuitem"
                                  tabIndex="-1"
                                  className="nmx-nav-link nmx-nav-link-mobile-subnav-overview"
                                  href={`${basePath}/disability-insurance`}>
                                  Disability Insurance Overview
                                </a>
                              </li>
                              <li
                                role="none"
                                className="nmx-nav-link-container">
                                <a
                                  role="menuitem"
                                  href="/disability-insurance"
                                  id="nmx-nav-link-primary-sub-level2-for-individuals"
                                  tabIndex="-1"
                                  className="nmx-nav-link nmx-nav-link-primary-sub-level2 nmx-subnav-level2-item-disability-insurance">
                                  For Individuals
                                </a>
                              </li>
                              <li
                                role="none"
                                className="nmx-nav-link-container">
                                <a
                                  role="menuitem"
                                  href="/disability-insurance-for-physicians-and-dentists"
                                  id="nmx-nav-link-primary-sub-level2-for-doctors-and-dentists"
                                  tabIndex="-1"
                                  className="nmx-nav-link nmx-nav-link-primary-sub-level2 nmx-subnav-level2-item-disability-insurance">
                                  For Doctors and Dentists
                                </a>
                              </li>
                              <li
                                role="none"
                                className="nmx-nav-link-container">
                                <a
                                  role="menuitem"
                                  href="/disability-insurance-calculator"
                                  id="nmx-nav-link-primary-sub-level2-disability-insurance-calculator"
                                  tabIndex="-1"
                                  className="nmx-nav-link nmx-nav-link-primary-sub-level2 nmx-nav-link-primary-sub-level2--last nmx-subnav-level2-item-disability-insurance has-icon">
                                  Disability Insurance Calculator{' '}
                                  <Icon variant="money-parachute-with-border" />
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/long-term-care-planning"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-insurance"
                              id="nmx-nav-link-primary-sub-insurance-long-term-care">
                              Long&#45;Term Care
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/annuities"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-nav-link-primary-sub--last nmx-subnav-item-insurance"
                              id="nmx-nav-link-primary-sub-annuities">
                              Annuities
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li
                        role="none"
                        itemProp="name"
                        className="nmx-nav-link-container nmx-nav-link-primary-container">
                        <a
                          role="menuitem"
                          itemProp="url"
                          aria-haspopup="true"
                          className="nmx-nav-link nmx-nav-link-primary"
                          href="/investments"
                          id="nmx-nav-link-primary-investments"
                          data-subnav-active="false"
                          aria-expanded="false">
                          Investments
                        </a>
                        <ul
                          role="menu"
                          className="reduced nmx-subnav nmx-subnav-investments"
                          aria-label="Investments Submenu">
                          <li
                            role="none"
                            className="nmx-nav-link-container nmx-nav-link-mobile-back-container">
                            <button
                              role="menuitem"
                              tabIndex="-1"
                              className="nmx-button nmx-button--tertiary nmx-nav-link nmx-nav-link-primary-sub--first nmx-nav-link-mobile-back">
                              Back to main menu
                              <span className="nmx-nav-mobile-subnav-bg"></span>
                            </button>
                          </li>
                          <li
                            role="none"
                            className="nmx-nav-link-container nmx-nav-link-mobile-subnav-overview-container">
                            <a
                              role="menuitem"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-mobile-subnav-overview"
                              href={`${basePath}/investments`}>
                              Investments Overview
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/investment-tools-and-solutions"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-investments"
                              id="nmx-nav-link-primary-sub-investment-solutions">
                              Investment Solutions
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/private-wealth-management"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-investments"
                              id="nmx-nav-link-primary-sub-investments-private-wealth-management">
                              Private Wealth Management
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/financial-advisory-programs"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-investments"
                              id="nmx-nav-link-primary-sub-advisory-programs">
                              Advisory Programs
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/private-client-services-wealth-management"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-investments"
                              id="nmx-nav-link-primary-sub-private-client-services-wealth-management">
                              Private Client Services
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/life-and-money/market-commentary"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub--last nmx-nav-link-primary-sub nmx-nav-link-primary-sub--last nmx-subnav-item-investments"
                              id="nmx-nav-link-primary-sub-investments-market-commentary">
                              Market Commentary
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li
                        role="none"
                        itemProp="name"
                        className="nmx-nav-link-container nmx-nav-link-primary-container">
                        <a
                          role="menuitem"
                          itemProp="url"
                          aria-haspopup="true"
                          className="nmx-nav-link nmx-nav-link-primary"
                          href="/life-and-money"
                          id="nmx-nav-link-primary-life-and-money"
                          data-subnav-active="false"
                          aria-expanded="false">
                          Life &#38; Money
                        </a>
                        <ul
                          role="menu"
                          className="reduced nmx-subnav nmx-subnav-life-and-money"
                          aria-label="Life &#38; Money Submenu">
                          <li
                            role="none"
                            className="nmx-nav-link-container nmx-nav-link-mobile-back-container">
                            <button
                              role="menuitem"
                              tabIndex="-1"
                              className="nmx-button nmx-button--tertiary nmx-nav-link nmx-nav-link-primary-sub--first nmx-nav-link-mobile-back">
                              Back to main menu
                              <span className="nmx-nav-mobile-subnav-bg"></span>
                            </button>
                          </li>
                          <li
                            role="none"
                            className="nmx-nav-link-container nmx-nav-link-mobile-subnav-overview-container">
                            <a
                              role="menuitem"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-mobile-subnav-overview"
                              href={`${basePath}/life-and-money`}>
                              Life &#38; Money Overview
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/life-and-money/your-family"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-life-and-money"
                              id="nmx-nav-link-primary-sub-your-family">
                              Your Family
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/life-and-money/your-home"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-life-and-money"
                              id="nmx-nav-link-primary-sub-your-home">
                              Your Home
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/life-and-money/market-commentary"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-life-and-money"
                              id="nmx-nav-link-primary-sub-life-and-money-market-commentary">
                              Market Commentary
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/life-and-money/your-career"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-subnav-item-life-and-money"
                              id="nmx-nav-link-primary-sub-your-career">
                              Your Career
                            </a>
                          </li>
                          <li role="none" className="nmx-nav-link-container">
                            <a
                              role="menuitem"
                              href="/life-and-money/money-basics"
                              tabIndex="-1"
                              className="nmx-nav-link nmx-nav-link-primary-sub nmx-nav-link-primary-sub--last nmx-subnav-item-life-and-money"
                              id="nmx-nav-link-primary-sub-money-basics">
                              Money Basics
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
            {/* remove non-applied DOM elements if logo-only header */}
            {!hideHeader && <UtilityNavigation env={env} />}
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

HeaderComponent.propTypes = {
  /** Env vars used in footer */
  env: PropTypes.shape({
    basePath: PropTypes.string.isRequired,
    nmxTemplateVersion: PropTypes.string.isRequired,
    public: PropTypes.shape({
      googlePlacesApiKey: PropTypes.string,
      googleFloodlightsId: PropTypes.string,
      googleAnalyticsTrackingId: PropTypes.string,
    }).isRequired,
    services: PropTypes.shape({
      loginPageUrl: PropTypes.string.isRequired,
      loginPageUrlBase: PropTypes.string.isRequired,
      userLogoutUrls: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  hideHeader: PropTypes.bool,
  headerIsOverlayed: PropTypes.bool,
  headerLogoEyebrow: PropTypes.bool,
  headerLogoEyebrowLarge: PropTypes.bool,
  headerWithoutBorder: PropTypes.bool,
  showInformationalBanner: PropTypes.bool,
  skipNavAside: PropTypes.bool,
};

HeaderComponent.defaultProps = {
  hideHeader: false,
  headerIsOverlayed: false,
  headerWithoutBorder: false,
  showInformationalBanner: false,
  skipNavAside: false,
};

export default HeaderComponent;
